

import React, { useState } from "react";

import { Button, Form, Grid, Input, theme, Typography } from "antd";
import { useUser } from "../../contexts/UserContext";

import { LockOutlined, MailOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { setSignUp } from "../../redux/slices/signUpSlice";
import { FETCH_SIGN_UP } from "../../redux/actions";
import { setSignUpContent } from "../../redux/slices/signUpContents";
import ErrorList from "./ErrorList";
import { SignIn, SignUp } from "../../redux/auth/action";
import { dir, t } from "i18next";

const { useToken } = theme;
const { useBreakpoint } = Grid;
const { Text, Title } = Typography;


const SignUpForm = ({ handleSwitchPage }) => {


    const errors = useSelector((state) => state.signUpErrorMessage)



    const { token } = useToken();
    const screens = useBreakpoint();
    const { userConfigs } = useUser();

    const onFinish = async (values) => {
        SignUp(values)
    };


    const styles = {
        container: {
            margin: "0 auto",
            padding: screens.md ? `${token.paddingXL}px` : `${token.sizeXXL}px ${token.padding}px`,
            width: "380px"
        },
        footer: {
            marginTop: token.marginLG,
            textAlign: "center",
            width: "100%"
        },
        forgotPassword: {
            float: "right"
        },
        header: {
            marginBottom: token.marginXL
        },
        section: {
            alignItems: "center",
            backgroundColor: userConfigs.dark ? 'transparent' : 'white',
            display: "flex",
            height: "auto",
            width: '100%',
            padding: '0px'

        },
        text: {
            color: token.colorTextSecondary
        },
        title: {
            fontSize: screens.md ? token.fontSizeHeading2 : token.fontSizeHeading3
        }
    };



    return (
        <section style={styles.section} dir={userConfigs.locale.locale === 'fa' || userConfigs.locale.locale === 'ar' ? 'rtl' :'ltr'}>
            <div style={styles.container}>
                <div style={styles.header}>
                    <Title style={styles.title}>{t('user.signUp')}</Title>
                </div>
                <Form
                    name="normal_login"
                    initialValues={{
                        remember: true,
                    }}
                    onFinish={onFinish}
                    layout="vertical"
                    requiredMark="optional"
                >
                    <Form.Item
                        name="email"
                        rules={[
                            {
                                type: "email",
                                required: true,
                                message: "Please input your Email!",
                            },
                        ]}
                    >
                        <Input
                            prefix={<MailOutlined />}
                            placeholder={t('user.email')}
                            style={{ padding: '10px' }}
                            autoComplete="new-email"
                        />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        rules={[
                            {
                                required: true,
                                message: "Please input your Password!",
                            },
                        ]}
                    >
                        <Input.Password
                            prefix={<LockOutlined />}
                            type="password"
                            placeholder={t('user.password')}
                            style={{ padding: '10px' }}
                            autoComplete="new-password"
                        />
                    </Form.Item>
                    <Form.Item
                        name="password_confirmation"
                        rules={[
                            {
                                required: true,
                                message: "Please input your Password again!",
                            },
                        ]}
                    >
                        <Input.Password
                            prefix={<LockOutlined />}
                            type="password"
                            placeholder={t('user.reapetPassword')}
                            style={{ padding: '10px' }}
                            autoComplete="new-password-reapet"
                        />
                    </Form.Item>
                    <ErrorList errors={errors} />
                    <Form.Item style={{ marginBottom: "0px" }}>
                        <Button block="true" type="primary" htmlType="submit">
                            {t('user.signUp')}
                        </Button>
                        <div style={styles.footer}>
                            <Text style={styles.text}>{t('user.Do_you_have_an_account')}</Text>{" "}
                            <Button style={{ margin: '0px 8px' }} onClick={handleSwitchPage}>{t('user.signInNow')}</Button>
                        </div>
                    </Form.Item>
                </Form>
            </div>
        </section>
    )
}

export default SignUpForm
